module.exports = __webpack_public_path__ + "static/media/L.1df88279.png";